import { store, getContext, getElement } from '@wordpress/interactivity';
import { QUERY_FILTER_NAMESPACE } from './constants';

const serializedValueSeparator = ',';

const { state, actions } = store(QUERY_FILTER_NAMESPACE, {
  context: {
  },

  state: {
    get selectedCount() {
      const context = getContext();

      return context.formValues.length;
    },

    get isPluralCount() {
      const context = getContext();
      return state.selectedCount !== 1;
    },

    get selectedCountLabel() {
      const context = getContext();
      return state.isPluralCount 
        ? context.label?.pluralName 
        : context.label?.singularName;
    },

    get filterLabel() {
      const context = getContext();
      const selectedCount = state.selectedCount;

      if (selectedCount < 1) {
        return `Select ${context.labels?.singularName} filters`;
      }

      const itemLabel = state.isPluralCount
        ? context.labels?.pluralName
        : context.labels?.singularName;

      return `${selectedCount} ${itemLabel} selected`;
    },
  },

  actions: {
    onInit: () => {
      const context = getContext();
      console.log(`[QueryDropdownFilter #init] context:`, context)

      actions.updateSerializedFormValues();
    },

    onFilterChange: (event) => {
      const catSlug = event?.target?.name;
      const isChecked = event?.target?.checked;

      const context = getContext();
      
      let {formValues: newFormValues} = context;
      if (isChecked) {
        if (!newFormValues.includes(catSlug)) {
          newFormValues = [...newFormValues, catSlug];
        }
      } else {
        newFormValues = newFormValues.filter((slug) => slug !== catSlug);
      }
      context.formValues = newFormValues;

      actions.updateSerializedFormValues();
    },

    updateSerializedFormValues: () => {
      const context = getContext();
      let serializedValue = null;
      if (Array.isArray(context.formValues) && context.formValues.length > 0) {
        serializedValue = context.formValues.join(serializedValueSeparator);
      }

      context.serializedFormValues[context.queryParamKey] = serializedValue;
    },
    
    onToggleOpen: (event) => {
      const context = getContext();
      context.isOpen = !context.isOpen;
    },

    onClickOutside: (event) => {
      const context = getContext();
      if (context.isOpen !== true) {
        // Dropdown is already collapsed, just ignore this.
        return;
      }
      
      // Dropdown is open, and we have a click. Let's see if it's on a child 
      // of the root element for this component.
      const { ref: rootElement } = getElement();
      const eventTarget = event.target;
      
      if (!(eventTarget instanceof HTMLElement)) {
        // ...not sure how this would even occur, but... let's just ignore 
        // clicks in this case.
        return;
      }
      
      // Only close if the click target was outside of our component.
      const isChildClickTarget = rootElement.contains(eventTarget);
      if (isChildClickTarget === false) {
        context.isOpen = false;
      }
    },
  },
});
